import type { FC } from "react";
import { useCallback, useState } from "react";
import { ImportDomainsModal } from "./ImportDomainsModal";
import { ImportDomainsContainer } from "./ImportDomains.styles";
import { allTrackers } from "app/services/track/track";
import { PlainTooltip } from "@similarweb/ui-components";
import type { IServices } from "../../CustomHooks/useMarketBuilderServices";
import type { IDomain } from "../../MarketBuilder.types";
import { IconButton } from "@similarweb/ui-components";

interface IImportDomainsProps {
    services: IServices;
    onImportDomains: (domains: IDomain[]) => void;
    selectedDomains: IDomain[];
    isDisabled: boolean;
}

export const ImportDomains: FC<IImportDomainsProps> = (props) => {
    const { services, onImportDomains, selectedDomains, isDisabled } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { translate } = services;
    const handleOpenModal = useCallback(() => {
        allTrackers.trackEvent("Button", "click", `By websites/ImportModal/openModal`);
        setIsModalOpen(true);
    }, [setIsModalOpen]);

    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false);
    }, [setIsModalOpen]);
    return (
        <>
            <ImportDomainsContainer>
                <PlainTooltip
                    cssClass="plainTooltip-element"
                    tooltipContent={translate("marketbuilder.import.disable.tooltip")}
                    placement="top"
                    enabled={isDisabled}
                >
                    <div>
                        <IconButton
                            type="outlined"
                            iconName="download"
                            iconSize="xs"
                            onClick={handleOpenModal}
                            isDisabled={isDisabled}
                        >
                            {services.translate("marketbuilder.websites.import.button")}
                        </IconButton>
                    </div>
                </PlainTooltip>
            </ImportDomainsContainer>
            <ImportDomainsModal
                isOpen={isModalOpen}
                onImportSuccess={onImportDomains}
                onClose={handleCloseModal}
                services={services}
                selectedDomains={selectedDomains}
                modalTitle={"Import websites"}
            />
        </>
    );
};
